import { Component, h, createRef } from 'preact';
import { InquiryListResponse } from 'types/inquiries';

interface InquiryGridLoadMoreTriggerProps {
  inquiries?: InquiryListResponse;
  onLoadTriggered?: () => void;
}

export class InquiryGridLoadMoreTrigger extends Component<InquiryGridLoadMoreTriggerProps> {
  intersectionObserver: IntersectionObserver;
  ref = createRef<HTMLDivElement>();

  componentDidMount() {
    this.intersectionObserver = new IntersectionObserver(
      (e) => this.onScreenEnter(e),
      {
        root: document.body,
        rootMargin: '128px'
      }
    );

    this.intersectionObserver.observe(this.ref.current);
  }

  onScreenEnter(entries: IntersectionObserverEntry[]) {
    if (!this.props.inquiries) return;
    const props = this.props;
    const inquiries = this.props.inquiries;

    entries.forEach(entry => {
      if (entry.target == this.ref.current && entry.isIntersecting) {
        if (inquiries.results.length < inquiries.count && props.onLoadTriggered) {
          this.props.onLoadTriggered();
        }
      }
    });
  }

  render(props: InquiryGridLoadMoreTriggerProps, state) {
    return (
      <div ref={ this.ref } />
    );
  }
}
